export const status_published = 'published';
export const status_draft = 'draft';
export const permission_admin = 'admin';
export const permission_user = 'user';